<script setup lang="ts">
import { NotificationChannelEnum } from '@/@core/fire-risk-settings/domain/enums/NotificationChannel.enum'

defineProps<{
	channels: NotificationChannelEnum[]
}>()

function getChannelTitle(channel: NotificationChannelEnum) {
	switch (channel) {
		case NotificationChannelEnum.EMAIL:
			return 'E-mail'
		case NotificationChannelEnum.WHATSAPP:
			return 'Whatsapp'
		case NotificationChannelEnum.TELEGRAM:
			return 'Telegram'
	}
}
</script>

<template>
	<div
		style="display: flex"
		class="gap-1"
	>
		<span
			v-for="channel in channels"
			:key="channel"
			class="border border-gray-medium text-s-bold !text-gray-medium rounded-full px-2 bg-white-neutral"
		>
			{{ getChannelTitle(channel) }}</span
		>
	</div>
</template>
